import React from 'react';
import { SectionSeparator } from '@styles/layout';
import { HotelContent } from '@model/iceberg/hotel-content';
import { Icons, State } from '@model/common';
import { useI18NextContext } from '@components/hooks';
import { ExpandableBulletPointList, TextDescriptionFade, Snackbar, SplitGallery } from '@components/common';
import { ProductDescription } from '@components/product/product-description';
import { LocalAreaInfo } from '@components/product/local-area';
import { Theme } from '@theme/base';
import { useTheme } from '@emotion/react';

export interface HotelInformationProps {
  hotel: HotelContent;
}

export const HotelInformation = ({ hotel }: HotelInformationProps) => {
  const t: any = useI18NextContext();
  const theme: Theme = useTheme();

  const {
    place,
    hotelRating,
    tripAdvisorRating,
    summary,
    facilities,
    facilityNotes,
    accessible,
    coordinates,
    location,
    hero,
    gallery
  } = hotel;
  const galleryImages = [hero].concat(gallery.filter(({ url }) => url !== hero.url));

  return (
    <>
      <ProductDescription
        place={place}
        hotelRating={Number(hotelRating)}
        tripAdvisorRating={tripAdvisorRating}
        isMultiCentre
      />
      <TextDescriptionFade description={summary || ''} isGhosting={!summary} />
      <SectionSeparator size={theme.custom.spacing.xxLarge} />
      <SplitGallery gallery={galleryImages} />
      <SectionSeparator size={theme.custom.spacing.xxLarge} />
      {facilities && !!facilities.length && (
        <>
          <ExpandableBulletPointList items={facilities} title={'product__facilities--title'} errata={facilityNotes} />
          <SectionSeparator size={theme.custom.spacing.xxLarge} />
        </>
      )}
      {!accessible && (
        <>
          <Snackbar icon={Icons.MOBILITY} state={State.INFO} text={t('product__accessibility--notice')} />
          <SectionSeparator size={theme.custom.spacing.xxLarge} />
        </>
      )}
      {coordinates && place && (
        <>
          <LocalAreaInfo
            mapMarkerLabel={place.hotel!.display}
            latitude={coordinates.latitude}
            longitude={coordinates.longitude}
            description={location}
          />
        </>
      )}
    </>
  );
};
